import { useContext, useEffect, useState } from 'react'
import { useLayout } from '_metronic/layout/core'
import { useNavigate } from 'react-router-dom'
import { UIContext } from 'Context/UI'
import { DefaultLayoutConfig } from '_metronic/layout/core'

const ViewModel = () => {
	const navigate = useNavigate()
	const { setCustomContentToolbar, setShowContentToolbar } = useContext(UIContext)
	const { config, setLayout } = useLayout()
	const [image, setImage] = useState<File | null>(null)
	const [showDeliveryVariant, setShowDeliveryVariant] = useState(false)

	const backMain = () => {
		navigate(-1)
	}

	const isClickDeliveryVairiant = () => {
		setShowDeliveryVariant(!showDeliveryVariant)
	}

	useEffect(() => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)

		setLayout({
			...config,
			pageTitle: {
				...config.pageTitle,
				display: false,
			},
		})

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)

			setLayout(DefaultLayoutConfig)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		backMain,
		image,
		setImage,
		setShowDeliveryVariant,
		isClickDeliveryVairiant,
		showDeliveryVariant,
	}
}

export default ViewModel
